import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = ({ isOpen, toggleSidebar, currentPath, isAdmin, isSchoolAdmin, isDistrict, user }) => {
  const menuItems = [
    {
      title: 'Dashboard',
      path: '/',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
      roles: ['ADMIN', 'SCHOOL_ADMIN', 'DISTRICT'],
    },
    {
      title: 'Users',
      path: '/users',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ),
      roles: ['ADMIN', 'SCHOOL_ADMIN', 'DISTRICT'],
    },
    {
      title: 'Districts',
      path: '/districts',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7h18M3 12h18M3 17h18" />
        </svg>
      ),
      roles: ['ADMIN'],
    },
    {
      title: 'Schools',
      path: '/schools',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      ),
      roles: ['ADMIN', 'SCHOOL_ADMIN', 'DISTRICT'],
    },
    {
      title: 'Courses',
      path: '/courses',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      ),
      roles: ['ADMIN'],
    },
    {
      title: 'Certificates',
      path: '/certificates',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
        </svg>
      ),
      roles: ['ADMIN', 'SCHOOL_ADMIN', 'DISTRICT'],
    },
  ].filter((item) => {
    if (isAdmin) return true;
    if (isSchoolAdmin) return item.roles.includes('SCHOOL_ADMIN');
    if (isDistrict) return item.roles.includes('DISTRICT');
    return false;
  });

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={toggleSidebar}
        />
      )}

      <aside
        className={`fixed lg:static inset-y-0 left-0 z-50 w-64 bg-sidebar-bg text-white transform ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:translate-x-0 transition-transform duration-300 ease-in-out`}
      >
        <div className="flex flex-col h-full">
          <div className="p-4 border-b border-primaryDark">
            <div className="flex items-center justify-between">
              <div className="flex-1 flex justify-center w-full">
                <img src="/logo.png" alt="READ 21 Logo" className="w-full h-auto max-h-20 object-contain" />
              </div>
              <button
                onClick={toggleSidebar}
                className="lg:hidden text-white hover:text-gray-300 ml-2 flex-shrink-0"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>

          <nav className="flex-1 overflow-y-auto py-4">
            <ul className="space-y-2 px-4">
              {menuItems.map((item) => {
                const schoolPath = isSchoolAdmin && item.title === 'Schools' && user?.school?.id 
                  ? `/schools/${user.school.id}` 
                  : item.path;
                const isActive = currentPath === item.path || (isSchoolAdmin && item.title === 'Schools' && currentPath === schoolPath);
                let displayTitle = item.title;
                if (!isAdmin) {
                  if (item.title === 'Users' && (isSchoolAdmin || isDistrict)) {
                    displayTitle = 'Teachers';
                  }
                  if (item.title === 'Schools' && isDistrict) {
                    displayTitle = 'List of Schools';
                  }
                  if (item.title === 'Schools' && isSchoolAdmin) {
                    displayTitle = 'School';
                  }
                }
                return (
                  <li key={item.path}>
                    <Link
                      to={schoolPath}
                      onClick={() => {
                        if (window.innerWidth < 1024) {
                          toggleSidebar();
                        }
                      }}
                      className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                        isActive
                          ? 'bg-active-bg text-white'
                          : 'text-gray-300 hover:bg-primaryDark hover:text-white'
                      }`}
                    >
                      {item.icon}
                      <span className="font-medium">{displayTitle}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </nav>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;

